export default __webpack_public_path__ + "static/medialinq-button-1-6d6e56c0b9c6d8f31a4c7211d990014f.png";